import { render } from "./WindowWebcam.vue?vue&type=template&id=510597e8&scoped=true"
import script from "./WindowWebcam.vue?vue&type=script&lang=js"
export * from "./WindowWebcam.vue?vue&type=script&lang=js"

import "./WindowWebcam.vue?vue&type=style&index=0&id=510597e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-510597e8"

export default script